import { inject, Injectable } from '@angular/core';
import { AlertData } from '../models';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertDialogComponent } from '../../pages/main/shared/components/alert-dialog/alert-dialog.component';
import { AlertDialogType } from '../enums';

@Injectable({ providedIn: 'root' })
export class AlertModalService {
  readonly dialog = inject(MatDialog);

  public open(data: AlertData): MatDialogRef<AlertDialogComponent, { confirmed: boolean; mfaCode?: string }> {
    return this.dialog.open(AlertDialogComponent, {
      panelClass: AlertDialogType.dialogClassName(data.type),
      data,
    });
  }
}
